export class BaseRequestModel {
    loggedInUserID: number;
    loggedInUserOfficeID: number;
    parentID?: number;
    roleID?:number;
    officeLevelID?:number;
    editedRoleID?:number;
}
